var map = {
	"./Start": 66,
	"./Start.js": 66,
	"./_Start.scss": 315,
	"./login/Start": 67,
	"./login/Start.js": 67,
	"./restricted/Start": 68,
	"./restricted/Start.js": 68,
	"./simplified/Start": 69,
	"./simplified/Start.js": 69
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 561;


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/Start ^\.\/.*$
// module id = 561
// module chunks = 0